import { Form, Input } from "decorator-form";

import InputType from "common/form/InputType";
import Slider from "common/form/widgets/common/Slider";
import ButtonSelect from "common/form/widgets/common/ButtonSelect";

const autoExpand = Slider.registerWithOptions({
	min: 0,
	max: 5,
	stepSize: 1
});

const overflowViews = ButtonSelect.registerWithOptions([
	{value: 'popover', label: 'Popover'},
	{value: 'overlay', label: 'Overlay'}
]);

@Form({title: "Menu Tree View Config"})
export class MenuTreeViewConfig {

	@Input({type: InputType.CHECKBOX, title: "Vertical"})
	public vertical?: boolean;

	@Input({type: InputType.CHECKBOX, title: "Accordion (Vertical Mode Only)"})
	public accordion?: boolean;

	@Input({
		type: autoExpand,
		title: "Auto Expand Depth",
		description: "accordion view only"
	})
	public autoExpand?: number;

	@Input({type: InputType.CHECKBOX, title: "Collapsible"})
	public collapsible?: boolean;

	@Input({type: InputType.CHECKBOX, title: "Collapse Overflow Into Dropdown (Horizontal Mode Only)"})
	public useOverflowList?: boolean;

	@Input({type: InputType.CHECKBOX, title: "Use Rows View"})
	public useRowsView?: boolean;

	@Input({type: InputType.CHECKBOX, title: "Minimal Dropdown Style"})
	public popoverMinimal?: boolean;

	@Input({type: InputType.CHECKBOX, title: "Icons"})
	public enableIcons?: boolean = true;

	@Input({type: InputType.CHECKBOX, title: "Labels"})
	public enableLabels?: boolean = true;

	@Input({type: InputType.CHECKBOX, title: "Tooltips"})
	public enableTooltips?: boolean;

	// font

	@Input({type: InputType.UNIT, title: "Font Size"})
	public fontSize: string;

	@Input({type: InputType.FONT_WEIGHT, title: "Font Weight"})
	public fontWeight: string;

	@Input({type: InputType.TEXT_TRANSFORM, title: "Text Transform"})
	public textTransform: string;

	// menu

	@Input({type: InputType.PADDING, title: "Menu Padding"})
	public padding: string;

	@Input({type: InputType.COLOR, title: "Menu Background"})
	public background: string;

	@Input({type: InputType.COLOR, title: "Text Color"})
	public color: string;

	@Input({type: InputType.NUMBER, title: "Minimum Width (triggers collapse)"})
	public collapseWidth: number;

	@Input({type: overflowViews, title: "Collapsed View"})
	public collapsedView: "popover" | "overlay";

	// links

	@Input({type: InputType.JUSTIFY, title: "Top Level Item Alignment"})
	public justifyContent: string;

	@Input({type: InputType.PADDING, title: "Link Padding"})
	public linkPadding: string;

    // Deprecated - avoid the use of margin and let the parent container handel spacing
	/// @Input({type: InputType.MARGIN, title: "Link Margin"})
	public linkMargin: string;

	@Input({type: InputType.COLOR, title: "Link Background Color"})
	public linkBackgroundColor: string;

	@Input({type: InputType.COLOR, title: "Link Hover Background"})
	public hoverBackground: string;

	@Input({type: InputType.COLOR, title: "Link Hover Text Color"})
	public hoverColor: string;

	@Input({type: InputType.COLOR, title: "Active Link Background"})
	public activeBackground: string;

	@Input({type: InputType.COLOR, title: "Active Link Color"})
	public activeColor: string;

	// active highlight/underline

	@Input({type: InputType.UNIT, title: "Active Highlight Width"})
	public activeHighlightWidth: string;

	@Input({type: InputType.COLOR, title: "Active Highlight Color"})
	public activeHighlightColor: string;

	@Input({type: InputType.UNIT, title: "Link Icon Padding"})
	public iconPadding: string;

	@Input({type: InputType.PADDING, title: "Expand Section Padding"})
	public expandPadding?: string;

	@Input({type: InputType.BOX_SHADOW, title: "Link Box Shadow"})
	public boxShadow: string;

	@Input({type: InputType.UNIT, title: "Minimum height"})
	public minHeight: string;

	@Input({type: InputType.BORDER, title: "Border"})
	public border?: string;

	@Input({type: InputType.CHECKBOX, title: "Bottom Border"})
	public borderBottom?: boolean = false;

	@Input({type: InputType.CHECKBOX, title: "Right Border"})
	public borderRight?: boolean = false;
}



// WEBPACK FOOTER //
// ./src/common/views/menuTree/MenuTreeViewConfig.ts